import { Link } from 'react-router-dom';
import { AGENT_SETUP_BASE, AGENT_SETUP_BACK_LABEL } from '../../constants/setupRoadmapSteps';

/**
 * Shared "back to agent setup" link. Single source of truth for path and label.
 */
function BackToAgentSetupLink({ className, style }) {
    return (
        <Link
            to={AGENT_SETUP_BASE}
            className={className}
            style={{
                color: '#007bff',
                textDecoration: 'none',
                fontSize: '14px',
                ...(style || {}),
            }}
        >
            ← {AGENT_SETUP_BACK_LABEL}
        </Link>
    );
}

export default BackToAgentSetupLink;
